var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap" },
    [
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "客服" } },
            [_c("tjkautocompleteall", { on: { change: _vm.updateTjkId } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "参培情况" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.searchData.tjkJoin,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "tjkJoin", $$v)
                    },
                    expression: "searchData.tjkJoin"
                  }
                },
                [
                  _c("el-option", {
                    key: "noJoin",
                    attrs: { label: "未参培", value: "noJoin" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "abandonNoSay",
                    attrs: {
                      label: "中途退出（无报备）",
                      value: "abandonNoSay"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "abandonAndSay",
                    attrs: {
                      label: "中途退出（有报备）",
                      value: "abandonAndSay"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "joinComplete",
                    attrs: { label: "完整参培", value: "joinComplete" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "平台考核" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchData.platformAppraise,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "platformAppraise", $$v)
                    },
                    expression: "searchData.platformAppraise"
                  }
                },
                [
                  _c("el-option", {
                    key: "pass",
                    attrs: { label: "通过", value: "pass" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "nopass",
                    attrs: { label: "未通过", value: "nopass" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "reject",
                    attrs: { label: "拒考", value: "reject" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商家考核" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchData.merchantAppraise,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "merchantAppraise", $$v)
                    },
                    expression: "searchData.merchantAppraise"
                  }
                },
                [
                  _c("el-option", {
                    key: "pass",
                    attrs: { label: "通过", value: "pass" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "nopass",
                    attrs: { label: "未通过", value: "nopass" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "录取状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchData.enrollState,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "enrollState", $$v)
                    },
                    expression: "searchData.enrollState"
                  }
                },
                [
                  _c("el-option", {
                    key: "Yes",
                    attrs: { label: "录取", value: "Yes" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "No",
                    attrs: { label: "释放", value: "No" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "None",
                    attrs: { label: "暂未处理", value: "None" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getExcel } },
                [_vm._v("下载查询结果")]
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                { on: { click: _vm.doDownload, command: _vm.doDownload } },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("\n          下载"),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right"
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "51" } }, [
                        _vm._v("下载平台考核")
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", { attrs: { command: "52" } }, [
                        _vm._v("下载商家考核")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("label", { staticClass: "upload-btn pic-upload-btn" }, [
                _c("span", [_vm._v("导入平台考核")]),
                _vm._v(" "),
                _c("input", {
                  ref: "referenceUpload",
                  staticClass: "file tj-btn tj-btn-blue",
                  attrs: { name: "file", type: "file", accept: ".xls,.xlsx" },
                  on: {
                    change: function($event) {
                      return _vm.importExcel($event)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "upload-btn pic-upload-btn" }, [
                _c("span", [_vm._v("导入商家考核")]),
                _vm._v(" "),
                _c("input", {
                  ref: "referenceUploadMerchant",
                  staticClass: "file tj-btn tj-btn-blue",
                  attrs: { name: "file", type: "file", accept: ".xls,.xlsx" },
                  on: {
                    change: function($event) {
                      return _vm.importMerchantExcel($event)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.enroll("Yes")
                    }
                  }
                },
                [_vm._v("录取")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.enroll("No")
                    }
                  }
                },
                [_vm._v("释放")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getTjkJoin } },
                [_vm._v("参培生成")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.tableData.length > 0
        ? _c(
            "div",
            { staticClass: "search-box" },
            [
              _c(
                "el-scrollbar",
                {
                  staticClass: "scroll-bar-x",
                  attrs: {
                    viewStyle: "display: inline-block; min-width: 100%;"
                  }
                },
                [
                  _c(
                    "children",
                    { attrs: { dataArr: _vm.headList } },
                    _vm._l(_vm.finalTableData, function(trlist, trIndex) {
                      return _c(
                        "tr",
                        { staticClass: "formcontent" },
                        [
                          _vm._l(trlist, function(item, index) {
                            return _c(
                              "td",
                              [
                                item.type == "TEXT"
                                  ? [
                                      index == 0 || index == 4
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.finalTableData[trIndex][
                                                  index
                                                ].value
                                              )
                                            )
                                          ])
                                        : [
                                            _vm.finalTableData[trIndex][index]
                                              .value != "" &&
                                            _vm.finalTableData[trIndex][index]
                                              .value != null
                                              ? [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        effect: "dark",
                                                        content:
                                                          _vm.finalTableData[
                                                            trIndex
                                                          ][index].value,
                                                        placement: "top"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "85%",
                                                          height: "40px"
                                                        },
                                                        attrs: {
                                                          editable: "false"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.finalTableData[
                                                              trIndex
                                                            ][index].value,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .finalTableData[
                                                                trIndex
                                                              ][index],
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "finalTableData[trIndex][index].value"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              : [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "85%",
                                                      height: "40px"
                                                    },
                                                    attrs: {
                                                      editable: "false"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.finalTableData[
                                                          trIndex
                                                        ][index].value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.finalTableData[
                                                            trIndex
                                                          ][index],
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "finalTableData[trIndex][index].value"
                                                    }
                                                  })
                                                ]
                                          ]
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type == "SELECT"
                                  ? [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100px" },
                                          attrs: { filterable: "" },
                                          model: {
                                            value:
                                              _vm.finalTableData[trIndex][index]
                                                .value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.finalTableData[trIndex][
                                                  index
                                                ],
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "finalTableData[trIndex][index].value"
                                          }
                                        },
                                        _vm._l(item.fieldOptions, function(
                                          m,
                                          key
                                        ) {
                                          return _c("el-option", {
                                            key: m.value,
                                            attrs: {
                                              label: m.describe,
                                              value: m.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              trlist.length > 0
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "link-text",
                                        staticStyle: {
                                          color: "cornflowerblue",
                                          margin: "3px 3px",
                                          float: "left"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.saveTjkJoin(
                                              _vm.tableData[trIndex],
                                              _vm.finalTableData[trIndex]
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("保存")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "link-text",
                                        staticStyle: {
                                          color: "cornflowerblue",
                                          margin: "3px 3px",
                                          float: "left"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.delTjk(
                                              _vm.tableData[trIndex]
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        2
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.searchData.enroll == "Yes" ? "录取" : "释放",
            visible: _vm.dialogEnrollVisible,
            center: "",
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogEnrollVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "通知消息", "label-width": "120px" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "350px" },
                    attrs: { type: "textarea", autocomplete: "off", rows: 6 },
                    model: {
                      value: _vm.searchData.msg,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "msg", $$v)
                      },
                      expression: "searchData.msg"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              this.searchData.enroll == "Yes" && this.way == "Excel"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "录取到店铺", "label-width": "120px" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            remote: "",
                            placeholder: "请设置目标店铺",
                            "remote-method": _vm.queryShopIdByName
                          },
                          model: {
                            value: _vm.searchData.shopId,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "shopId", $$v)
                            },
                            expression: "searchData.shopId"
                          }
                        },
                        _vm._l(_vm.shopOptions, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.shopName, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogEnrollVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.doEnroll } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fcebd0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fcebd0e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/trainCheck/trainNameList.vue
// module id = 1477
// module chunks = 0